export const APP_NAME = 'PanDa'

export const ADDRESS_LINE_1 = 'Henryka Sienkiewicza 44/1'
export const ADDRESS_LINE_2 = '81-374 Gdynia, Polska'
export const PHONE_NUMBER = '+48 888 589 189'
export const WEBSITE_ADDRESS = 'www.desmart.com'
export const CONTACT_EMAIL = 'hello@desmart.com'
